import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { InternalRoutes } from '../../../../../../enum/InternalRoutes';
import { IParams } from '../../../../../../model/shared/IParams';
import { CampaignValidationStatusEnum } from '../../../../../../enum/CampaignValidationStatusEnum';

interface IStepperRoutingProps {
    submitStepHandler?: () => void;
    status?: string;
    approvalStatus?: string;
    isNextDisabled?: boolean;
}

export function StepperRouting({
    submitStepHandler,
    status,
    isNextDisabled = false,
    approvalStatus,
}: IStepperRoutingProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const route = location.pathname;
    const { id } = useParams<keyof IParams>();

    const [stepperStep, setStepperStep] = useState('');

    const navigateTo = () => {
        if (status === 'draft') {
            navigate(`${InternalRoutes.BRAND_DASHBOARD}`);
        } else if (route.includes('overview')) {
            navigate(`${InternalRoutes.BRAND_CAMPAIGN_DASHBOARD}/${id}`);
        } else {
            navigate(`${InternalRoutes.BRAND_CAMPAIGN_CREATE}/${id}/overview`);
        }
    };
    useEffect(() => {
        const lastElement = route.split('/').pop();
        setStepperStep(lastElement ?? '');
    }, []);

    const prevStep = () => {
        navigate(`${InternalRoutes.BRAND_CAMPAIGN_CREATE}/${id}/step${+stepperStep[stepperStep.length - 1] - 1}`);
    };

    return (
        <div className="d-flex flex-wrap justify-content-between my-2">
            <Button onClick={navigateTo} size="sm" className="mt-2 mt-md-0" variant="outline-primary">
                {t('general.button.cancel')}
            </Button>
            <div className=" mt-md-0 d-flex mt-2">
                <Button
                    onClick={prevStep}
                    size="sm"
                    variant="outline-primary"
                    className={`mr-2 ${(stepperStep === 'step1' || stepperStep === 'overview') && 'd-none'}`}
                >
                    {t('general.button.back')}
                </Button>
                {stepperStep === 'overview' ? (
                    <Button
                        className="w-100"
                        size="sm"
                        // disabled={status === 'published' && approvalStatus !== 'rejected'}
                        onClick={() => {
                            submitStepHandler && submitStepHandler();
                        }}
                        variant="primary"
                    >
                        {approvalStatus === CampaignValidationStatusEnum.APPROVED
                            ? t('general.button.update')
                            : t('general.publish_campaign')}
                    </Button>
                ) : (
                    <Button
                        className="w-100"
                        onClick={() => {
                            submitStepHandler && submitStepHandler();
                        }}
                        disabled={isNextDisabled}
                        size="sm"
                        variant="primary"
                    >
                        {t('general.button.continue')}
                    </Button>
                )}
            </div>
        </div>
    );
}
